import dashboard from '@/components/dashboard'
import monev_kabupaten from '@/components/data_master/kabupaten/monev_kabupaten'
import monev_kecamatan from '@/components/data_master/kecamatan/monev_kecamatan'
import monev_kel_des from '@/components/data_master/kel_des/monev_kel_des'
import monev_sekolah from '@/components/data_master/sekolah/monev_sekolah'
import monev_user from '@/components/data_master/user/monev_user'
import monev_wilayah from '@/components/data_master/wilayah/monev_wilayah'
import instansi from '@/components/data_master/instansi/instansi'
import kanwil from '@/components/data_master/kanwil/kanwil'


function loggedInRedirectDashboard(to, from, next) {
    if (localStorage.token) {
      next('/dashboard');
    } else {
      next();
    }
  }
  
  function isLoggedIn(to, from, next) {
    if (localStorage.token) {
      next();
    } else {
      next('/monev_login');
    }
  }
  
  var routes = [{
    path: '/',
    name: '/',
    component: dashboard,
    beforeEnter: isLoggedIn,
  },
  {
    path: '/dashboard',
    name: '/dashboard',
    component: dashboard,
    beforeEnter: isLoggedIn,
  },
  {
    path: '/monev_kabupaten',
    name: 'monev_kabupaten',
    component: monev_kabupaten,
    beforeEnter: isLoggedIn,
  },
  {
    path: '/monev_kecamatan',
    name: 'monev_kecamatan',
    component: monev_kecamatan,
    beforeEnter: isLoggedIn,
  },
  {
    path: '/monev_kel_des',
    name: 'monev_kel_des',
    component: monev_kel_des,
    beforeEnter: isLoggedIn,
  },
  {
    path: '/monev_sekolah',
    name: 'monev_sekolah',
    component: monev_sekolah,
    beforeEnter: isLoggedIn,
  },
  {
    path: '/monev_user',
    name: 'monev_user',
    component: monev_user,
    beforeEnter: isLoggedIn,
  },
  {
    path: '/monev_wilayah',
    name: 'monev_wilayah',
    component: monev_wilayah,
    beforeEnter: isLoggedIn,
  },
  {
    path: '/instansi',
    name: 'instansi',
    component: instansi,
    beforeEnter: isLoggedIn,
  },
  {
    path: '/kanwil',
    name: 'kanwil',
    component: kanwil,
    beforeEnter: isLoggedIn,
  },
  
  
  ]


  export default routes